import { render } from "./CookieNotice.vue?vue&type=template&id=0b34478e&scoped=true"
import script from "./CookieNotice.vue?vue&type=script&lang=js"
export * from "./CookieNotice.vue?vue&type=script&lang=js"

import "./CookieNotice.vue?vue&type=style&index=0&id=0b34478e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b34478e"]])

export default __exports__